<template>
  <div class="">
    <el-form :model="form" :rules="rules" ref="form" >
      <el-form-item prop="inputValue">
        <el-input 
          v-model="form.inputValue" 
          placeholder="Please enter sheet name within 15 characters "
          maxlength="15"
          show-word-limit
          ref="inputRef"
          class="input"
          @keydown.native.prevent.enter="handleSave"
        ></el-input>
      </el-form-item>
      <el-form-item ></el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$emit('close')">Cancel</el-button>
      <el-button type="primary" @click="handleSave">Save</el-button>
    </div>
  </div>
</template>

<script>
import { validEmoji, validHtml } from "@/utils/validate.js"
export default {
  props: [ 'cbs', 'value', 'select' ],
  data() {

    function validateValue(rule, value, callback) {
      const test = /[【：？\:\\\/\?\*\[\]】]/;
      if (test.test(value)) {
        callback(new Error('Can not contain illegal characters :【：？:\\\/?*[]】'))
      }else if(validHtml(value)) {
        callback(new Error('Can not contain emojis or HTML tags'))
      }
      else {
        if (validEmoji(value)) {
           callback(new Error('Can not contain emojis or HTML tags'))
        }else {
          callback()
        }
      }
    }

    return {
      form: {
        inputValue: this.value
      },
      rules: {
        inputValue: [
          { required: true, message: 'Please enter sheet name within 15 characters', trigger: 'blur' },
          {  max: 15, message: 'Please enter sheet name within 15 characters', trigger: 'blur' },
          { validator: validateValue, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
      (this.select||this.value)&& this.selectInputText()
  },
  methods: {
    handleSave() {
      this.$refs['form'].validate((valid) => {
          if (valid) {
            this.cbs.onSubmit(this.form.inputValue)
          } else {
            return false;
          }
        });
    },
    selectInputText() {
      this.$refs.inputRef.select()
      this.$refs.inputRef.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    text-align: center;
    margin-top: 30px;
  }
  .input::v-deep input::selection {
    background: #bad7fb;
    color: #000;
  }
</style>
